import { LoadingSpinner } from './loading-spinner'

interface LoadingIndicatorProps {
    loadingMessage?: string
    secondaryMessage?: string
}

export const LoadingIndicator = ({ loadingMessage, secondaryMessage }: LoadingIndicatorProps) => {
    return (
        <div
            className="h-full w-full flex flex-col justify-center items-center p-4 flex-grow-1"
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <div className="flex flex-col items-center w-full">
                {loadingMessage && (
                    <p className="mt-6 text-xl text-lp-dark1 text-center leading-7">
                        {loadingMessage}
                    </p>
                )}

                {secondaryMessage && (
                    <p className="mt-6 text-base text-lp-dark1 text-center leading-7">
                        {secondaryMessage}
                    </p>
                )}
            </div>
            <div className="w-fit mt-4">
                <LoadingSpinner className="w-auto" aria-hidden="true" />
            </div>
        </div>
    )
}
